import React from 'react';

import MUIButton from '@material-ui/core/Button';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  btnDangerContained: {
    background: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    '&:hover': {
      background: theme.palette.error.dark
    }
  }
}));

export default function Button(props) {
  const classes = useStyles();

  const { color, className, children, ...rest } = props;
  const forwardColor = color === 'danger' ? 'primary' : color;

  const classesName = classnames(className, {
    [classes.btnDangerContained]:
      color === 'danger' && rest.variant === 'contained'
  });

  return (
    <MUIButton className={classesName} color={forwardColor} {...rest}>
      {children}
    </MUIButton>
  );
}
